<template>
  <div class="footer container-fluid">
    <div>
      <div class="logo">
        <router-link to="/">
          <img alt="LES CEO – coaching en capital intérieur et pilotage du système nerveux pour entrepreneurs, dirigeants, entreprises" src="../assets/svg/logo.svg" />
        </router-link>
        <span class="span-bold">L’impact commence de l’intérieur, et c’est depuis le Centre que tout s’aligne.</span>
      </div>
      <div class="footer-content">
        <div class="link">
          <ul class="footer-link">
            <li>
              <router-link to="/mentions-legales" class="dropdown-item" href="#">Mentions légales</router-link>
            </li>
            <li>
              <router-link to="/politique-confidentialite" class="dropdown-item" href="#">politique-confidentialite</router-link>
            </li>
          </ul>
        </div>
        <div class="social">
          <ul class="social-media">
            <li>
              <a href="https://www.instagram.com/lesceo_/?hl=fr" target="_blank"><i class="bi bi-instagram"></i></a>
            </li>
            <li>
              <a href="https://fr.linkedin.com/in/hasna-hajji-81254717b" target="_blank"><i class="bi bi-linkedin"></i></a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@les.ceo?_t=ZN-8yZxkHFk7hm&_r=1" target="_blank"><i class="bi bi-tiktok"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p class="text-center">
        Copyright© les CEO 2025 - Tous droits réservés - All rights
        reserved
      </p>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  .footer {
    padding: 10px;
    background: #FCFAF8;

    @media (min-width: 200px) and (max-width: 768px) {
      padding: 24px;
    }

    a {
      color: black;
      text-decoration: none;
      font-size: 14px;
    }

    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 20px;

      .span-bold {
        margin: 0 !important;
        color: #850A56;
      }
    }

    img {
      height: 70px;
      width: 200px;
    }

    .footer-content {
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      padding: 10px;

      img {
        width: 200px;
        height: 65px;
      }

      ul {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 10px;
        padding: 0;
        margin: 0;

        li {
          .dropdown-item:hover {
            background-color: inherit;
          }
        }

        @media (min-width: 200px) and (max-width: 768px) {
          display: block;
        }
      }

      .social-media {
        display: flex;
        justify-content: center;

        @media screen and (min-width: 200px) and (max-width: 768px) {
          display: block;
        }

        li {
          a {
            font-size: 1.5rem;
            margin-right: 10px;
          }
        }
      }
    }

    .copyright {
      padding: 15px 0;

      p {
        text-align: center;
        font-size: 12px !important;
        margin: 0 !important;
      }
    }

    // 🌍 **Responsive Design**
    @media (max-width: 768px) {
      .footer-content {
        flex-direction: column;
        text-align: center;

        img {
          width: 150px;
          height: 50px;
        }

        ul {
          display: block;
        }
      }

      .social-media {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 10px;
      }

      .logo {
        flex-direction: column;
      }
    }
  }
</style>